// needed to set the path for Images used in JS files.
// import was required to set the value before the other imports.
import "./assetsDirectory.js";

// Helper Files
import "../../Common/js/commonFiles.js";

// Javascript Apps
import "../../Common/js/jsComponents.js";
import initStoryBuilder from "../../Common/js/components/StoryBuilder/initStoryBuilder.js";

// React Apps
import "../../Common/js/reactComponents.js";

// USP JavaScript Apps

// USP React Apps

// This is required to make Storybook run JS when patterns are choosen
// document.addEventListener("DOMContentLoaded", () => {
//init vanilla js components
//render react components
// });

document.addEventListener("DOMContentLoaded", () => {
  // Story Builder component is not initiated with other components because
  // it needs to be initialized after the Youtube React component mounts
  initStoryBuilder();
});
